import React from 'react';
import { Modal, Button, Icon } from 'semantic-ui-react';
import { apolloClientHolder } from '@crispico/foundation-react';
import { ModalExt, Severity } from '@crispico/foundation-react/components/ModalExt/ModalExt';
import { REGENERATE_INVOICE_BASED_ON_TASKS, REGENERATE_INVOICE_BASED_ON_LINES_OR_DATA } from './queries';

export enum RecalculationType { USING_INVOICE_LINES, USING_INVOICE_DATA, USING_TASKS }

interface InvoiceRecalculationProps {
    showModal: boolean;
    entityId: number | undefined;
    type: RecalculationType | undefined;
    onClose: () => void;
}

interface InvoiceRecalculationState {
    confirmationModal: boolean
}

export class InvoiceRecalculationModal extends React.Component<InvoiceRecalculationProps, InvoiceRecalculationState> {
    constructor(props: InvoiceRecalculationProps) {
        super(props);
        this.state = {
            confirmationModal: false
        }
    }

    protected async regenerateInvoice() {
        if (!this.props.entityId || this.props.type === undefined) {
            return;
        }
        const mutation = this.props.type === RecalculationType.USING_TASKS ? REGENERATE_INVOICE_BASED_ON_TASKS : REGENERATE_INVOICE_BASED_ON_LINES_OR_DATA;
        const variables = this.props.type === RecalculationType.USING_TASKS ? { invoiceId: this.props.entityId } : { invoiceId: this.props.entityId, regenerateLines: this.props.type === RecalculationType.USING_INVOICE_DATA };
        await apolloClientHolder.apolloClient.mutate({ mutation, variables, context: { showSpinner: true } });
        this.props.onClose();
        this.setState({ confirmationModal: true });
    }

    protected renderConfirmationModal() {
        return <ModalExt size="tiny" severity={Severity.INFO} open={this.state.confirmationModal}
            content={_msg("InvoiceRecalculationModal.regenerationComplete")} onClose={() => this.setState({ confirmationModal: false })}
            actions={[<Button primary content={_msg("general.ok")} onClick={() => this.setState({ confirmationModal: false })} />]} />
    }

    render() {
        const message = this.props.type === RecalculationType.USING_INVOICE_LINES
            ? _msg("InvoiceRecalculationModal.recalculateBasedOnLinesAlert.content") : this.props.type === RecalculationType.USING_INVOICE_DATA
            ? _msg("InvoiceRecalculationModal.recalculateBasedOnDataAlert.content") : _msg("InvoiceRecalculationModal.recalculateBasedOnTaskAlert.content");

        return <>
            <ModalExt size="tiny" open={this.props.showModal} onClose={() => this.props.onClose()} >
                <Modal.Header><Icon name="warning circle"/>{_msg("InvoiceRecalculationModal.header.label")}</Modal.Header>
                <Modal.Content>{message}</Modal.Content>
                <Modal.Actions>
                    <Button onClick={() => this.regenerateInvoice()}>{_msg("general.ok")}</Button>
                    <Button onClick={() => this.props.onClose()}>{_msg("general.cancel")}</Button>
                </Modal.Actions>
            </ModalExt>
            {this.renderConfirmationModal()}
        </>
    }
}